import type { IconData } from '@stacksjs/iconify-core'

export const ua4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"gold\" d=\"M0 0h640v480H0z\"/><path fill=\"#0057b8\" d=\"M0 0h640v240H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ua4x3
